// ============================================================================
// packagesAPI — cliente dos endpoints /api/packages-*
// ============================================================================
// Substitui o ciclo localStorage → cloud sync de fk_packages.json. Agora
// cada operação vai DIRETO no Postgres via API → sem race condition.
// Garantia ACID: nenhum cenário de sumiço/regressão possível.
// ============================================================================

function getAuthHeaders() {
  try {
    const raw = sessionStorage.getItem('fk_session');
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    const token = parsed?.sessionToken;
    return token ? { 'x-session-token': token } : {};
  } catch {
    return {};
  }
}

export async function fetchPackages() {
  const r = await fetch('/api/packages-list', {
    cache: 'no-store',
    headers: { 'Cache-Control': 'no-store' },
  });
  if (!r.ok) throw new Error(`Falha ao listar pacotes (${r.status})`);
  const json = await r.json();
  return json.packages || [];
}

export async function upsertPackage(pkg) {
  const r = await fetch('/api/packages-upsert', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify(pkg),
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({}));
    throw new Error(err.error || `Falha ao salvar pacote (${r.status})`);
  }
  const json = await r.json();
  return json.package;
}

// Migração 1-shot: lê fk_packages.json (Storage) e upserta na tabela packages.
// Usado pra trazer os pacotes promovidos do Avec (com preço por unidade) pro
// Postgres. Idempotente — rodar de novo não duplica. Master só.
export async function importPackagesFromStorage({ onlyAvec = true } = {}) {
  const r = await fetch('/api/packages-import-from-storage', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify({ onlyAvec }),
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({}));
    throw new Error(err.error || `Falha ao importar pacotes (${r.status})`);
  }
  return r.json();
}

export async function deletePackage(id) {
  const r = await fetch('/api/packages-delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    body: JSON.stringify({ id }),
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({}));
    throw new Error(err.error || `Falha ao deletar pacote (${r.status})`);
  }
  return true;
}
